import { forwardRef, type Ref, type SVGProps } from "react";
const IconCloseCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 28a12 12 0 1 1 12-12 12 12 0 0 1-12 12m0 2A14 14 0 1 0 2 16a14 14 0 0 0 14 14" />
    <path d="m17.41 16 4.3-4.29a1 1 0 0 0-1.42-1.42L16 14.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z" />
  </svg>
);
const ForwardRef = forwardRef(IconCloseCircleOutlineSVG);
ForwardRef.displayName = "IconCloseCircleOutline";
export { ForwardRef as IconCloseCircleOutline };
